import i18n from '@online-offer/i18n';
import {isToday, isYesterday} from 'date-fns';
import {Tooltip} from 'platform/components';
import {Text, Show, HStack} from 'platform/foundation';
import {DateTimeFormat, useDateTimeFormatter} from 'platform/locale';

import {parseDate} from 'shared/web';

interface EventDateProps {
  timestamp: string;
  isRead?: boolean;
  isReadAfterText?: boolean;
}

export function EventDate(props: EventDateProps) {
  const formatDateTime = useDateTimeFormatter();
  const parsedTimestamp = parseDate(props.timestamp);

  const isActivityToday = isToday(parsedTimestamp);
  const isActivityYesterday = isYesterday(parsedTimestamp);

  return (
    <HStack spacing={1}>
      <Show when={props.isRead && !props.isReadAfterText}>
        <Text size="xxSmall" color="secondary" alternative>
          {props.isRead ? i18n.t('chat.message.read') : ''}
        </Text>
      </Show>
      <Text size="xxSmall" color="secondary">
        <Tooltip label={formatDateTime('dateTimeShort', parsedTimestamp)}>
          <Show when={isActivityToday}>
            {i18n.t('general.labels.today')} {formatDateTime('timeShort', parsedTimestamp)}
          </Show>
          <Show when={isActivityYesterday}>{i18n.t('general.labels.yesterday')}</Show>
        </Tooltip>
        <Show when={!isActivityToday && !isActivityYesterday}>
          <DateTimeFormat value={parsedTimestamp} format="dateTimeShort" />
        </Show>
      </Text>
      <Show when={props.isRead && props.isReadAfterText}>
        <Text size="xxSmall" color="secondary" alternative>
          {props.isRead ? i18n.t('chat.message.read') : ''}
        </Text>
      </Show>
    </HStack>
  );
}
